import { PayloadAction } from '@reduxjs/toolkit'
import * as Actions from '.'

export const setUserAccount = (accountCode: string): PayloadAction<string> => {
	return { type: Actions.USER_ACCOUNT_SET_REQUESTED, payload: accountCode };
}